<template>

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="-11.5 780.5 24 24" >
<path d="M9.18,787.11l-8.15-4.46c-0.33-0.18-0.73-0.18-1.07,0l-8.15,4.46c-0.36,0.2-0.58,0.57-0.58,0.97v8.86
	c0,0.41,0.22,0.78,0.58,0.97l8.15,4.46c0.33,0.18,0.73,0.18,1.07,0l8.15-4.46c0.36-0.19,0.58-0.57,0.58-0.97v-8.86
	C9.76,787.67,9.54,787.3,9.18,787.11 M9.02,796.94c0,0.13-0.07,0.26-0.19,0.32l-8.15,4.46c-0.11,0.06-0.24,0.06-0.36,0l-8.15-4.46
	c-0.12-0.06-0.19-0.19-0.19-0.32v-8.86c0-0.13,0.07-0.26,0.19-0.32l8.15-4.46c0.11-0.06,0.25-0.06,0.36,0l8.15,4.46
	c0.12,0.06,0.19,0.19,0.19,0.32V796.94z"/>
</svg>

</template>